/**
 * --------------------------------------------------------
 * VDB Framework
 * The Automotive Intelligence Layer for Shopify
 *
 * Version : 1.0.0
 * Release : Foundation
 * Build   : 003
 * Commit  : 003.1
 * Module  : HTTP Provider
 * --------------------------------------------------------
 */
(function (window) {
  "use strict";

  const VDB = window.VDB = window.VDB || {};

  function config() {
    return window.VDBConfig || { apiBase: "/apps/vdb", requestTimeoutMs: 12000 };
  }

  function buildUrl(path, params) {
    const base = String(config().apiBase || "/apps/vdb").replace(/\/$/, "");
    const url = new URL(base + path, window.location.origin);
    Object.entries(params || {}).forEach(function (entry) {
      const key = entry[0];
      const value = entry[1];
      if (value !== "" && value !== null && value !== undefined) {
        url.searchParams.set(key, String(value));
      }
    });
    return url.toString();
  }

  async function request(path, params) {
    const controller = new AbortController();
    const timeout = Number(config().requestTimeoutMs) || 12000;
    const timer = window.setTimeout(function () { controller.abort(); }, timeout);

    try {
      const response = await window.fetch(buildUrl(path, params), {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
        signal: controller.signal
      });
      if (!response.ok) {
        throw new Error("VDB API " + response.status + ": " + response.statusText);
      }
      return await response.json();
    } catch (error) {
      if (VDB.events && VDB.eventNames) {
        VDB.events.emit(VDB.eventNames.ERROR, {
          source: "provider.http",
          path: path,
          error: error
        });
      }
      throw error;
    } finally {
      window.clearTimeout(timer);
    }
  }

  VDB.providers.register("http", {
    name: "http",
    request: request,
    getMakes: function () { return request("/makes"); },
    getModels: function (make) { return request("/models", { make: make }); },
    getYears: function (make, model) { return request("/years", { make: make, model: model }); },
    getEngines: function (make, model, year) {
      return request("/engines", { make: make, model: model, year: year });
    },
    resolveVehicle: function (params) { return request("/resolve", params || {}); },
    health: function () { return request("/health"); }
  });
})(window);
